<template>
  <span
    v-tooltip="'Quota resets on ' + renews"
    class="badge badge-pill"
    :class="{
      'badge-danger': systemTags.includes('subscription_level:NONE'),
      'badge-warning': outOfQuota && !systemTags.includes('subscription_level:NONE'),
      'badge-accent': !outOfQuota && systemTags.includes('subscription_level:TRIAL'),
      'badge-info': !outOfQuota && !systemTags.includes('subscription_level:TRIAL'),
      'badge-wide': larger,
      'badge-narrow': !larger,
    }"
  >
    <span v-if="systemTags.includes('api_science')" :class="{ larger: larger }"> API Science </span>
    <span v-else-if="systemTags.includes('api_expert')" :class="{ larger: larger }">
      API.expert
    </span>
    <span v-else-if="systemTags.includes('subscription_level:NONE')" :class="{ larger: larger }">
      Suspended
    </span>
    <span
      v-else-if="systemTags.includes('subscription_level:CONTRACT')"
      :class="{ larger: larger }"
    >
      Enterprise
    </span>
    <span
      v-else-if="
        systemTags.includes('subscription_level:PLAN') &&
        systemTags.includes('recurly_sub_state:canceled')
      "
      :class="{ larger: larger }"
    >
      Canceled
    </span>
    <span
      v-else-if="
        systemTags.includes('subscription_level:PLAN') &&
        systemTags.includes('recurly_sub_state:expired')
      "
      :class="{ larger: larger }"
    >
      Expired
    </span>
    <span
      v-else-if="
        systemTags.includes('subscription_level:PLAN') &&
        systemTags.includes('recurly_sub_state:failed')
      "
      :class="{ larger: larger }"
    >
      Failed
    </span>
    <span
      v-else-if="
        systemTags.includes('subscription_level:PLAN') &&
        systemTags.includes('recurly_sub_state:future')
      "
      :class="{ larger: larger }"
    >
      Future
    </span>
    <span
      v-else-if="
        systemTags.includes('subscription_level:PLAN') &&
        systemTags.includes('recurly_sub_state:paused')
      "
      :class="{ larger: larger }"
    >
      Suspended
    </span>
    <span
      v-else-if="
        systemTags.includes('subscription_level:PLAN') &&
        systemTags.includes('recurly_sub_state:active')
      "
      :class="{ larger: larger }"
    >
      Subscribed
    </span>
    <span
      v-else-if="!systemTags.includes('out_of_quota') && trialExpires"
      :class="{ larger: larger }"
    >
      Trial
    </span>
    <span
      v-else-if="!systemTags.includes('out_of_quota') && !trialExpires"
      :class="{ larger: larger }"
    >
      Free
    </span>
    <span v-else-if="systemTags.includes('out_of_quota')" :class="{ larger: larger }">
      Out of Quota
    </span>
    <span v-else>Unknown</span>
    <span v-if="larger && systemTags.includes('api_science')">
      <br /><span class="small">Contact support for invoices</span>
    </span>
    <span v-else-if="larger && systemTags.includes('recurly_sub_state:active')">
      <br /><span class="small">Plan renews on {{ renews }}</span></span
    >
    <span v-else-if="larger && systemTags.includes('recurly_sub_state:canceled')">
      <br /><span class="small">Plan expires on {{ renews }}</span>
    </span>
    <span v-else-if="larger && !systemTags.includes('subscription_level:NONE') && !trialExpires">
      <br /><span class="small">Quota resets on {{ renews }}</span>
    </span>
    <span v-else-if="larger && !systemTags.includes('subscription_level:NONE') && trialExpires">
      <br /><span class="small">Trial ends on {{ trialExpiresStr }}</span>
    </span>
  </span>
</template>

<script>
import moment from 'moment-timezone';

export default {
  name: 'SubscriptionPill',
  props: {
    systemTags: {
      type: Array,
      required: true,
    },
    larger: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    renewsMoment() {
      const theDate =
        this.getTagVal('trial_ends_at') || this.getTagVal('recurly_sub_current_period_ends_at');
      const planTag = this.getTagVal('recurly_plan_code');
      return theDate && (!planTag || !planTag.endsWith('yearly'))
        ? moment.utc(theDate)
        : moment.utc().startOf('month').add(1, 'month');
    },
    renews() {
      return this.renewsMoment.format('ll');
    },
    outOfQuota() {
      return this.systemTags.includes('out_of_quota') || this.systemTags.includes('over_quota');
    },
    trialExpires() {
      return this.getTagVal('trial_ends_at');
    },
    trialExpiresStr() {
      return this.trialExpires ? moment.utc(this.trialExpires).format('ll') : null;
    },
  },
  methods: {
    getTagVal(tagName) {
      const found = this.systemTags.find((tag) => tag.indexOf(tagName) === 0);
      if (found) {
        return found.replace(`${tagName}:`, '');
      }
      return null;
    },
  },
};
</script>

<style scoped>
.badge-accent {
  background-color: var(--accent);
}
.badge-wide {
  min-width: 160px;
}
.badge-narrow {
  min-width: 96px;
}
</style>
